export default "__VITE_PUBLIC_ASSET__fb54013e__"